import { Clock3, Mail, ShieldCheck } from "lucide-react";

import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { formatMinutesDuration, getTmaPackageRows } from "./formatters";

export default function ClientPackagesView({ user, onContact }) {
  const packages = user.tma_packages?.length
    ? user.tma_packages
    : user.tma_enabled
      ? [{ id: "total", label: "Forfait TMA", minutes: user.tma_minutes_total }]
      : [];
  const packageRows = getTmaPackageRows(packages, user.tma_minutes_used);

  return (
    <div className="support-client-packages-page">
      <div className="support-client-packages-hero">
        <div>
          <h2>Bonjour,</h2>
          <p>Voici le suivi de vos forfaits de maintenance.</p>
        </div>
        <Button type="button" className="btn-secondary" onClick={onContact}>
          <Mail className="w-4 h-4" />
          Nous contacter
        </Button>
      </div>

      {!user.tma_enabled || !user.tma_visible_to_client ? (
        <Card className="support-content-card">
          <CardContent>
            <p className="body-small">Aucun forfait TMA n'est visible pour le moment.</p>
          </CardContent>
        </Card>
      ) : (
        <>
          <section className="support-client-tma-overview">
            <div className="support-client-tma-metric">
              <span className="support-client-tma-icon is-green">
                <Clock3 className="w-7 h-7" />
              </span>
              <div>
                <span>Temps restant</span>
                <strong className="is-green">{formatMinutesDuration(user.tma_minutes_remaining)}</strong>
                <small>sur tous vos forfaits</small>
              </div>
            </div>
            <div className="support-client-tma-divider" />
            <div className="support-client-tma-metric">
              <span className="support-client-tma-icon">
                <Clock3 className="w-7 h-7" />
              </span>
              <div>
                <span>Temps utilise</span>
                <strong>{formatMinutesDuration(user.tma_minutes_used)}</strong>
                <small>au total</small>
              </div>
            </div>
          </section>

          <section className="support-client-packages-card">
            <h3>Mes forfaits de maintenance</h3>
            <div className="support-client-package-table">
              <div className="support-client-package-row is-head">
                <span>Forfait</span>
                <span>Inclus</span>
                <span>Utilise</span>
                <span>Restant</span>
              </div>
              {packageRows.map((item, index) => (
                <div key={item.id} className="support-client-package-row">
                  <span className="support-client-package-name">
                    <span className={`support-client-package-icon is-${index % 2 === 0 ? "green" : "blue"}`}>
                      <ShieldCheck className="w-5 h-5" />
                    </span>
                    <strong>{item.label}</strong>
                  </span>
                  <span>{formatMinutesDuration(item.minutes)}</span>
                  <span className="support-client-package-used">
                    <strong>{formatMinutesDuration(item.used)}</strong>
                    <small>{item.progress}%</small>
                    <span className="support-client-package-progress">
                      <i style={{ width: `${item.progress}%` }} />
                    </span>
                  </span>
                  <span className="support-client-package-remaining">{formatMinutesDuration(item.remaining)}</span>
                </div>
              ))}
              {packageRows.length === 0 && (
                <div className="support-client-package-empty">Aucun forfait disponible.</div>
              )}
            </div>
          </section>
        </>
      )}
    </div>
  );
}
